import { ReactComponent as ArrowGoIcon } from 'assets/images/elearning/navigation/arrow_go_icon.svg';
import { ReactComponent as TickIcon } from 'assets/images/elearning/navigation/tick_icon.svg';
import clsx from 'clsx';
import { PATHS } from 'constants/routes';
import { FC } from 'react';
import { Link, useMatch } from 'react-router-dom';
import { Topic } from 'types/elearning';
import cls from './list-item.module.scss';

interface IProps {
    topic: Topic & { topics?: Topic[]};
    path: string;
    isGreen?: boolean;
}

export const ListItem: FC<IProps> = ({ topic, path, isGreen }) => {
    const linkToElement = path === 'q' ? `${PATHS.HAND_HYGIENE}/${path}/quiz` : `${PATHS.HAND_HYGIENE}/${path}/${topic?.topics[0]?.path}`;
    return (
        <li className={cls.item}>
            <div className={cls.line}></div>
            <Link
                className={clsx(cls.itemLink, {
                    [cls.itemLinkActive]: useMatch(
                        linkToElement
                    ),
                    [cls.itemLinkBlocked]: !topic?.is_available,
                })}
                to={linkToElement}
            >
                <div className={cls.itemTopicWrapper}>
                    <div
                        className={clsx(cls.itemStatus, {
                            [cls.itemStatusDone]: topic?.is_done,
                            [cls.itemStatusGreen]: topic?.is_done && isGreen,
                        })}
                    >
                        <TickIcon />
                    </div>
                    <span className={cls.capitalize}>{topic?.name || topic?.topics[0]?.name}</span>
                </div>
                <ArrowGoIcon className={cls.itemArrow} />
            </Link>
        </li>
    );
};
